import { useEffect, useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import { PageSizeSelector, DEFAULT_PAGE_SIZE } from '@/components/common/PageSizeSelector';

/** Client-side row paging for already-filtered report rows (exports keep using the full row set). */
export function useClientPage(rows, resetKey) {
  const [size, setSize] = useState(DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(1);
  const all = useMemo(() => rows || [], [rows]);
  const pages = Math.max(1, Math.ceil(all.length / size));
  useEffect(() => { setPage(1); }, [resetKey, size]);
  const cur = Math.min(page, pages);
  return { slice: all.slice((cur - 1) * size, cur * size), page: cur, pages, size, setSize, setPage, total: all.length, start: (cur - 1) * size };
}

export function ClientPager({ p, testid = 'client-pager' }) {
  if (!p.total) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 border-t text-xs" data-testid={testid}>
      <PageSizeSelector value={p.size} onChange={p.setSize} testid={`${testid}-size`} />
      <span className="text-muted-foreground" data-testid={`${testid}-info`}>{p.start + 1}–{Math.min(p.start + p.size, p.total)} of {p.total}</span>
      <div className="flex gap-1">
        <Button size="sm" variant="outline" className="h-7" disabled={p.page <= 1} onClick={() => p.setPage(p.page - 1)} data-testid={`${testid}-prev`}>Prev</Button>
        <Button size="sm" variant="outline" className="h-7" disabled={p.page >= p.pages} onClick={() => p.setPage(p.page + 1)} data-testid={`${testid}-next`}>Next</Button>
      </div>
    </div>
  );
}
